import React from 'react'
import PropTypes from 'prop-types'
import { Navigate as Redirect } from 'react-router'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { cloneDeep, isNil, isUndefined } from 'lodash'
import Component from '../common/Component'
import withRouter from '../../lib/withRouter'
import actions from '../../actions/Users'
import { createFlashMessage } from '../../actions/FlashMessages'
import InternalUserForm from './InternalUserForm'
import alert from '../../alert'

export class InternalUserEdit extends Component {
  static propTypes = {
    params: PropTypes.object,
    update: PropTypes.func.isRequired,
    show: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    showReset: PropTypes.func.isRequired,
    requestInProgress: PropTypes.bool,
    generalError: PropTypes.string,
    resourceErrors: PropTypes.object,
    attributes: PropTypes.object,
    updated: PropTypes.bool.isRequired,
    createFlashMessage: PropTypes.func.isRequired,
    defaultRoles: PropTypes.array.isRequired
  }

  componentDidMount() {
    this.props.show(this.id)
  }

  componentWillUnmount() {
    this.props.reset()
    this.props.showReset()
  }

  get id() {
    return this.props.params.id
  }

  get initialAttributes() {
    const newAttributes = cloneDeep(this.props.attributes)

    return newAttributes
  }

  handleSubmit = (values) => {
    this.props
      .update(this.id, this.translateValues(values))
      .then(({ id }) => {
        this.props.createFlashMessage('Updated user', { id: parseInt(id, 10), tag: 'index' })
      })
  }

  translateValues = (values) => {
    const newValues = cloneDeep(values)

    if (!isNil(newValues.roles)) { newValues.user_roles = this.buildRoles(newValues) }

    return newValues
  }

  buildRoles = (values) => {
    const roles = values.roles.map((roleName) => ({
      id: this.props.defaultRoles.find((role) => role.name === roleName).id,
      name: this.props.defaultRoles.find((role) => role.name === roleName).name
    }))

    return this.addRoles(roles).concat(this.removeRoles(roles))
  }

  addRoles = (roles) => {
    const userRoles = this.initialAttributes.user_roles
    const addedRoles = roles.filter((role) => isUndefined(userRoles.find((userRole) => userRole.role_id === role.id)))

    return addedRoles.map((role) => ({ role_id: role.id }))
  }

  removeRoles = (roles) => {
    const userRoles = this.initialAttributes.user_roles
    const roleIds = roles.map((role) => { return role.id })

    const deletedRoles = userRoles.filter((userRole) => !roleIds.includes(userRole.role_id))

    return deletedRoles.map((role) => ({ ...role, _destroy: true }))
  }

  redirect(path) {
    return <Redirect replace to={path} />
  }

  render() {
    const {
      generalError,
      resourceErrors,
      requestInProgress,
      attributes,
      updated
    } = this.props

    if (!isNil(generalError)) {
      alert(generalError)
    }

    if (!isNil(this.destroyError)) {
      alert(this.destroyError)
    }

    if (isNil(attributes)) {
      return null
    }

    if (updated) {
      return this.redirect('/internal_users')
    }

    const errors = isNil(resourceErrors) ? {} : resourceErrors

    return (
      <div className="content">
        <h2>Edit Internal User</h2>
        <div>
          <InternalUserForm
            handleSubmit={this.handleSubmit}
            errors={errors}
            requestInProgress={requestInProgress}
            submitLabel="Update User"
            defaultRoles={this.props.defaultRoles}
            initialValues={this.initialAttributes}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const slice = state.users.update
  const showSlice = state.users.show

  return {
    generalError: slice.generalError,
    resourceErrors: slice.resourceErrors,
    requestInProgress: slice.requestInProgress,
    attributes: showSlice.attributes,
    id: slice.id,
    updated: slice.updated,
    defaultRoles: state.login.session.configuration.roles
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  update: actions.update.main,
  reset: actions.update.reset,
  show: actions.show.main,
  showReset: actions.show.reset,
  createFlashMessage
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InternalUserEdit))
